import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    quote: "Dawid wjechał, ogarnął i wyszedł - system działa miesiąc po wdrożeniu jak zegarek. Polecam każdemu kto ma SaaS.",
    name: "Marcin K.",
    role: "Founder e-commerce 3-spółkowy",
    initials: "MK"
  },
  {
    quote: "Najmniej toxic CRM expert w Polsce. Nie sprzedaje magii - buduje systemy które rzeczywiście działają.",
    name: "Maciej W.",
    role: "COO firmy deweloperskiej",
    initials: "MW"
  },
  {
    quote: "Zaoszczędził mi 25h/tydzień. Po prostu. Bez bullshit konsultingu, bez 'zrobimy ofertę za 2 tygodnie'.",
    name: "Marek M.",
    role: "CEO Kognita",
    initials: "MM"
  }
];

export default function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section aria-label="Opinie klientów" className="py-16 md:py-24 bg-bg">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 lg:px-16">
        
        {/* Header */}
        <motion.div
          className="mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="w-8 h-px bg-stroke"></div>
            <span className="text-xs text-muted uppercase tracking-[0.3em]">Co mówią klienci</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl tracking-tight font-light text-text-primary mb-4">
            Realne <span className="font-display italic">opinie</span>
          </h2>
        </motion.div>

        {/* Grid */}
        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <motion.div
              key={idx}
              className="bg-surface border border-stroke rounded-3xl p-8 hover:scale-[1.02] transition-transform duration-300 flex flex-col"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.6, delay: 0.1 * idx, ease: "easeOut" }}
            >
              <Quote className="w-6 h-6 text-accent-from mb-6 opacity-50" />
              
              <p className="text-text-primary text-lg leading-relaxed mb-8 italic flex-grow">
                "{t.quote}"
              </p>
              
              <div className="flex items-center gap-4 pt-6 border-t border-stroke/50">
                <div className="w-12 h-12 rounded-full bg-stroke flex items-center justify-center text-text-primary text-sm font-medium shrink-0">
                  {t.initials}
                </div>
                <div>
                  <div className="text-sm font-medium text-text-primary">{t.name}</div>
                  <div className="text-xs text-muted mt-0.5">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
